export default [
    {
        path: '',
        name: 'pageTataKelola',
        component: () => import('./page-tata-kelola')
    }
]